import "./carousel.css";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import ThumbnailSlider from "./ThumbnailSlider";
import AssetImageModal from "./AssetImageModal";
import MainDisplay from "./MainDisplay";
import { CarouselProvider, useCarouselContext } from "../../context/CarouselContext";
import { CameraDirection } from "./cameraTagPosition";
import { useEffect } from "react";


interface CarouselProps {
  images: any[];
  assetId: string;
  height?: string | number;
  minHeight?: string | number;
  cameraDirection?: CameraDirection;
}

const CarouselContent: React.FC<{ assetId: string; height?: string | number; minHeight?: string | number }> = ({ assetId, height, minHeight }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { uniqueImageTypes, selectedType, filteredImages, setCarouselAssetId } = useCarouselContext();

  useEffect(() => {
    setCarouselAssetId(assetId);
  }, [assetId, setCarouselAssetId]);

  const isUcOnly = ((uniqueImageTypes.length === 1 && ["img_uc_dewarp", "img_uc"].includes(filteredImages[0]?.imageType || '')) ||
    (uniqueImageTypes.length > 1 && ["img_uc_dewarp", "img_uc"].includes(selectedType)));


  return (
    <Box sx={{
      width: "100%",
      height: height || '100%',
      minHeight: minHeight || (isMobile ? "250px" : "400px"),
      margin: "0 auto",
      position: "relative",
      backgroundColor: theme.palette.background.paper,
      p: isMobile ? "8px" : "20px 10px",
      borderRadius: 2,
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column'
    }}>
      {filteredImages.length > 0 &&
        <MainDisplay />
      }
      {!isUcOnly && (
        <ThumbnailSlider />
      )}
      <AssetImageModal />
    </Box>
  );
};

const Carousel: React.FC<CarouselProps> = ({ images, assetId, height, minHeight, cameraDirection }) => {
  return (
    <CarouselProvider images={images} cameraDirection={cameraDirection}>
      <CarouselContent assetId={assetId} height={height} minHeight={minHeight} />
    </CarouselProvider>
  );
};

export default Carousel;
